import { authActionTypes } from '.';
import { ActionTypes, AuthState } from './interfaces';

const initState: AuthState = {
  loading: true,
  refreshingTokenInProgress: false,
  actionAccumulator: [],
  user: {
    firstName: null,
    lastName: null,
    role: null,
    id: null,
    avatar: null,
    isCan: null,
    isWkd: null,
  },
  parent: null,
};

export default function authReducer(state: AuthState = initState, action: ActionTypes): AuthState {
  switch (action.type) {
    case authActionTypes.WHO_AM_I_START:
      return {
        ...state,
        loading: true,
      };
    case authActionTypes.WHO_AM_I_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          firstName: action.payload.user.firstName,
          lastName: action.payload.user.lastName,
          role: action.payload.user.role,
          id: action.payload.user.id,
          avatar: action.payload.user.avatar,
          isCan: action.payload.user.isCan,
          isWkd: action.payload.user.isWkd,
        },
        parent: action.payload.user.parent
          ? {
              ...state.parent,
              firstName: action.payload.user.parent.firstName,
              lastName: action.payload.user.parent.lastName,
              role: action.payload.user.parent.role,
              id: action.payload.user.parent.id,
              avatar: action.payload.user.parent.avatar,
              isCan: null,
              isWkd: action.payload.user.isWkd,
            }
          : null,
      };
    case authActionTypes.REFRESH_TOKEN_START:
      return {
        ...state,
        refreshingTokenInProgress: true,
      };
    case authActionTypes.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        refreshingTokenInProgress: false,
      };
    case authActionTypes.REFRESH_TOKEN_FAIL:
      return {
        ...state,
        refreshingTokenInProgress: false,
      };
    case authActionTypes.ACCUMULATE_ACTION:
      //zapisz akcję wraz z danymi do akumulatora
      return {
        ...state,
        actionAccumulator: [...state.actionAccumulator, action.payload.action],
      };
    case authActionTypes.CLEAN_ACCUMULATOR:
      //wyczyść tablicę actionAccumulator
      return {
        ...state,
        actionAccumulator: initState.actionAccumulator,
      };
    case authActionTypes.RESET_USER:
      // reset danych użytkownika w stanie aplikacji
      return {
        ...state,
        user: {
          ...initState.user,
        },
      };
    case authActionTypes.RESET_REDUCERS:
      // reset danych stora
      return {
        ...initState,
      };
    default:
      return state;
  }
}
